import {createStore, applyMiddleware, combineReducers, compose} from 'redux'
import {thunk} from 'redux-thunk'

import providerRegionReducer from 'js/components/ProviderRegion/reducers'

const rootReducer = combineReducers({
  providerRegion: providerRegionReducer,
})

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const configureStore = (initialState = {}) => {
  const enhancers = composeEnhancers(applyMiddleware(thunk))

  return createStore(rootReducer, initialState, enhancers)
}
